var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"patreon-label",style:({ backgroundColor: ` rgb(0 0 0 / ${_vm.transparent})` })},[_c(_setup.BKSvgIcon,{attrs:{"color":"var(--color-gold-800)","height":"12px","name":"patreon","width":"12px"}}),(!_vm.isOnlyIcon)?_c('span',[_vm._v("Patreon")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }